import React from 'react';

const DropdownField = ({ path, value, options, updateCharacter }) => {
  const handleChange = (e) => {
    updateCharacter(path, e.target.value);
  };

  return (
    <select value={value} onChange={handleChange}>
      {options.map((option) => (
        <option key={option} value={option}>
          {option}
        </option>
      ))}
    </select>
  );
};

export default DropdownField;
